import { render, staticRenderFns } from "./vacancies.vue?vue&type=template&id=7ef0b6d0&"
import script from "./vacancies.vue?vue&type=script&lang=js&"
export * from "./vacancies.vue?vue&type=script&lang=js&"
import style0 from "./vacancies.vue?vue&type=style&index=0&id=7ef0b6d0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports